import React from 'react'
import { ArrowLeft } from 'lucide-react'
import { Button } from '../components/ui/button'
import { useNavigate } from 'react-router-dom'
import { TermsOfUseContent, PrivacyPolicyContent } from '@adthlete/shared-frontend'

const TermsAndConditions: React.FC = () => {
  const navigate = useNavigate()

  const handleBackClick = () => {
    navigate('/')
  }

  return (
    <div className="min-h-screen bg-background p-4">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-4 mb-6">
          <Button
            onClick={handleBackClick}
            variant="outline"
            size="sm"
            className="bg-card text-foreground border-foreground/10 hover:bg-foreground/10"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back
          </Button>
          <div className="flex items-center gap-3">
            <img
              src="https://adthlete.us-iad-1.linodeobjects.com/public/adthlete_logomark.png"
              alt="Athios Logo"
              className="w-8 h-8"
            />
            <h1 className="text-2xl font-bold text-foreground">Terms and Conditions</h1>
          </div>
        </div>

        <div className="space-y-6">
          <TermsOfUseContent maxHeight="h-128" />
          <PrivacyPolicyContent maxHeight="h-128" />
        </div>
      </div>
    </div>
  )
}

export default TermsAndConditions
